import { UserError } from '../errors';

export function rejectKnownSnakeCaseConfigKeys(
  value: Record<string, unknown>,
  keys: string[],
  source: string,
): void {
  const found = keys.find((key) => key in value);
  if (!found) {
    return;
  }
  throw new UserError(
    `Use camelCase config keys in ${source}; snake_case key "${found}" is not supported.`,
  );
}
